import React from 'react';
import { FaBalanceScale, FaChalkboardTeacher, FaTools, FaUserGraduate } from 'react-icons/fa';
import { GiGraduateCap } from 'react-icons/gi';
import { MdWork } from 'react-icons/md';
import { CategoriaEdital } from '../../../../model/processo/Categoria';
import { EtapaEditaisProps } from './types';
import { formatarCategoria } from './utils';

type CategoriaConfig = { icone: React.ReactElement; cor: string; fundo: string };

const configPorCategoria: Record<CategoriaEdital, CategoriaConfig> = {
  [CategoriaEdital.ALUNO_TECNICO]:   { icone: <FaTools size={28} color="#1a7f5a" />,             cor: '#1a7f5a', fundo: '#e6f4ef' },
  [CategoriaEdital.ALUNO_GRADUACAO]: { icone: <FaUserGraduate size={28} color="#1a7f5a" />,      cor: '#1a7f5a', fundo: '#e6f4ef' },
  [CategoriaEdital.ALUNO_POS]:       { icone: <GiGraduateCap size={28} color="#1a7f5a" />,       cor: '#1a7f5a', fundo: '#e6f4ef' },
  [CategoriaEdital.SERVIDOR]:        { icone: <MdWork size={28} color="#7c4dbd" />,              cor: '#7c4dbd', fundo: '#f0eafa' },
  [CategoriaEdital.PROCURADOR]:      { icone: <FaBalanceScale size={28} color="#c0622a" />,      cor: '#c0622a', fundo: '#fdf0e8' },
  [CategoriaEdital.DOCENTE]:         { icone: <FaChalkboardTeacher size={28} color="#1a6fa8" />, cor: '#1a6fa8', fundo: '#e8f3fb' },
};

const gruposCategorias = [
  [CategoriaEdital.ALUNO_TECNICO, CategoriaEdital.ALUNO_GRADUACAO, CategoriaEdital.ALUNO_POS],
  [CategoriaEdital.SERVIDOR, CategoriaEdital.PROCURADOR, CategoriaEdital.DOCENTE],
];

const EtapaEditais: React.FC<EtapaEditaisProps> = ({
  formData,
  onInputChange,
  onEditalChange,
  onAddEdital,
  onRemoveEdital,
  slideDirection
}) => {
  return (
    <div style={{
      animation: slideDirection === 'right' ? 'slideInRight 0.3s ease-out' : 'slideInLeft 0.3s ease-out'
    }}>
      <div className="mb-3">
        <label className="form-label fw-semibold mb-2" style={{ fontSize: '14px', color: '#495057' }}>
          Categoria dos Editais
        </label>
        <div className="d-flex flex-column gap-2">
          {gruposCategorias.map((grupo, gi) => (
            <div key={gi} className="d-flex gap-2">
              {grupo.map(categoria => {
                const selecionada = formData.categoria === categoria;
                const { icone, cor, fundo } = configPorCategoria[categoria];
                return (
                  <button
                    key={categoria}
                    type="button"
                    onClick={() => onInputChange('categoria', categoria)}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      flex: 1,
                      padding: '16px 8px',
                      borderRadius: '12px',
                      border: `2px solid ${selecionada ? cor : '#e9ecef'}`,
                      backgroundColor: selecionada ? fundo : 'white',
                      color: selecionada ? cor : '#6c757d',
                      cursor: 'pointer',
                      transition: 'all 0.15s ease',
                      fontSize: '12px',
                      fontWeight: selecionada ? 600 : 400,
                      lineHeight: '1.3',
                      textAlign: 'center',
                    }}
                  >
                    {icone}
                    {formatarCategoria(categoria)}
                  </button>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      {formData.categoria && (
        <>
          <hr style={{ borderColor: '#e9ecef', margin: '20px 0 16px' }} />
          <div className="d-flex flex-column gap-3">
            {formData.editais.map((edital, index) => (
              <div key={index} className="edital-card">
                <div className="d-flex gap-3 align-items-start">
                  <div className="flex-grow-1">
                    <input
                      type="text"
                      className="form-control modern-input mb-2"
                      value={edital.nome}
                      onChange={e => onEditalChange(index, 'nome', e.target.value)}
                      placeholder={`Nome do edital ${index + 1}`}
                    />
                    <input
                      type="url"
                      className="form-control modern-input"
                      value={edital.url || ''}
                      onChange={e => onEditalChange(index, 'url', e.target.value)}
                      placeholder="URL do edital (opcional)"
                      style={{ fontSize: '13px' }}
                    />
                  </div>
                  <div className="d-flex flex-column align-items-end gap-2">
                    {formData.editais.length > 1 && (
                      <button
                        type="button"
                        className="remove-btn"
                        onClick={() => onRemoveEdital(index)}
                        title="Remover edital"
                      >
                        <i className="bi bi-x" style={{ fontSize: '20px' }}></i>
                      </button>
                    )}
                    <div className="form-check d-flex align-items-center gap-2 mb-0">
                      <input
                        className="form-check-input modern-checkbox"
                        type="checkbox"
                        id={`hasChamadas-${index}`}
                        checked={edital.hasChamadas}
                        onChange={e => onEditalChange(index, 'hasChamadas', e.target.checked.toString())}
                      />
                      <label className="form-check-label" htmlFor={`hasChamadas-${index}`} style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>
                        Prevê Chamadas
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <button type="button" className="add-btn" onClick={onAddEdital} style={{ alignSelf: 'flex-start', fontSize: '13px', padding: '6px 14px' }}>
              <i className="bi bi-plus-lg me-1"></i>
              Adicionar edital
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EtapaEditais;
